const classrooms = {
	title: "Klasserom",
	new_classroom: "Nytt klasserom",
	edit_classroom: "Rediger: {name}",
	view_classroom: "Vis: {name}",
	list_title: "Klasseromsliste",
	list_subtitle: "Håndter klasserom",
	create_title: "Opprett klasserom",
	update_title: "Oppdater klasserom",
	address_title: "Adresse",
	details_title: "Klasseromsdetaljer",
	id: "ID",
	name: "Tittel",
	address_id: "Adresse",
	place: "Sted",
	created_by: "Opprettet av",
	status: "Status",
};
export default classrooms;